<template>
  <div class="body-wrapper">
    <div class="header">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        {{ communityName }}
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <!--bedz u desnom uglu se prikazuje samo kada je otvorena kartica-->
          <i :class="tableBadge" class="badge--mod" v-if="openedCard"></i>
        </transition>
      </h1>
      <!-- <h2>{{ communityType }}</h2> -->
    </div>

    <transition
      mode="out-in"
      enter-active-class="animated faster fadeIn"
      leave-active-class="animated faster fadeOut"
    >
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
/*
 * community view. it is consisted of three cards
 * which are loaded with router-view.
 * CommunityCards is set as default view (can be seen
 * in router) as Community's default child route.
 * */
export default {
  computed: {
    ...mapState(['openedCard']),
    /*
     * heading is independent unlike router-view
     * so we need to keep its state in vuex*/
    communityName() {
      return this.$store.getters.getCommunityName;
    },
    /*getting proper badge*/
    tableBadge() {
      return this.$store.getters['table/getActiveCardBadge'];
    }
  },
  data() {
    return {
      communityMode: true
    };
  },
  methods: {
    /*
     * we need to track if our card is opened/closed
     * for proper badge handling
     * */
    ...mapMutations(['cardClosed']),
    /*
     * back method is needed because back button
     * doesn't work as browser back button
     * but follows application flow which is
     * communities <-> community <-> community/[tickets, polls, members]
     * */
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
.body-wrapper {
  display: block;
  padding: 10px;
  // height: 100%;
}

h1,
h2 {
  text-align: center;
}
h1 {
  padding-top: 25px;
  position: relative;
}
h2 {
  color: #636363;
  padding-bottom: 20px;
}

#arrow {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

#arrow:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.badge--mod {
  position: absolute;
  right: 0;
  left: unset;
  border-radius: 50%;
  padding: 5px;
  margin-right: 10px;
}
</style>
